// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    customer_portal_find_accounts: 'Buscando entre las cuentas del portal',
    customer_portal_pending_with_customer: 'Mirando qué nos tienen que contestar los clientes',
    customer_portal_find_requests: 'Buscando entre las solicitudes del portal',
    customer_portal_request_detail: 'Leyendo una solicitud del portal',
    customer_portal_summary: 'Contando lo que está haciendo el portal',
    customer_portal_publish_record: 'Publicando en el portal del cliente',
    customer_portal_reply_to_request: 'Contestando una solicitud del portal',
  },
  ca: {
    customer_portal_find_accounts: 'Cercant entre els comptes del portal',
    customer_portal_pending_with_customer: 'Mirant què ens han de respondre els clients',
    customer_portal_find_requests: 'Cercant entre les sol·licituds del portal',
    customer_portal_request_detail: 'Llegint una sol·licitud del portal',
    customer_portal_summary: 'Comptant el que està fent el portal',
    customer_portal_publish_record: 'Publicant al portal del client',
    customer_portal_reply_to_request: 'Responent una sol·licitud del portal',
  },
  en: {
    customer_portal_find_accounts: 'Looking through the portal accounts',
    customer_portal_pending_with_customer: 'Checking what the customers still owe us an answer on',
    customer_portal_find_requests: 'Looking through the portal requests',
    customer_portal_request_detail: 'Reading a portal request',
    customer_portal_summary: 'Counting what the portal is doing',
    customer_portal_publish_record: 'Publishing a record to the customer portal',
    customer_portal_reply_to_request: 'Answering a portal request',
  },
  fr: {
    customer_portal_find_accounts: 'Recherche parmi les comptes du portail',
    customer_portal_pending_with_customer: 'Ce à quoi les clients doivent encore répondre',
    customer_portal_find_requests: 'Recherche parmi les demandes du portail',
    customer_portal_request_detail: 'Lecture d’une demande du portail',
    customer_portal_summary: 'Bilan de l’activité du portail',
    customer_portal_publish_record: 'Publication sur le portail client',
    customer_portal_reply_to_request: 'Réponse à une demande du portail',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
